import axios from '../helpers/axiosHelper'
import { IReduxAction } from '../reducers'
import { PartyAction } from '../config/partyConfig'

export function getPartyList(): IReduxAction {
    return {
        type: PartyAction.GetList,
        payload: axios.get('/party/list'),
    }
}
